/**
 *
 * FlashCardDetail
 *
 */

import FlashCardToggleRevise from '@/views/FlashCard/FlashCardDetail/components/FlashCardHeader/FlashCardToggleRevise.vue';
import QuestionFontSize from '@/views/FlashCard/FlashCardDetail/components/FlashCardHeader/QuestionFontSize.vue';
import ToggleFilterBtn from '@/views/FlashCard/FlashCardDetail/components/FlashCardHeader/ToggleFilterBtn.vue';
import ToggleSheetBtn from '@/views/FlashCard/FlashCardDetail/components/FlashCardHeader/ToggleSheetBtn.vue';
import { FlashCardExerciseTypeMixin } from '@/scripts/FlashCard/FlashCardDetail/mixins/FlashCardExerciseTypeMixin';

export default {
  name: 'FlashCardHeader',

  mixins: [FlashCardExerciseTypeMixin],

  components: {
    FlashCardToggleRevise,
    QuestionFontSize,
    ToggleFilterBtn,
    ToggleSheetBtn,
  },

  methods: {
    closeCardModal() {
      this.$emit('close-card-modal');
    },
  },
};
